/**
 * 设备时钟与服务端的偏差，秒。
 *
 * <p>倒计时**不能直接用 `Date.now()`**：手机系统时钟差多少，倒计时就差多少。
 * 两个人并排看同一期，一个显示 1:53、一个显示 2:03，谁也不知道该信哪个
 * （2026-08-19 真机反馈）。
 *
 * <p>在 Milhar 上这还不只是显示问题：同一个 `nowSec` 还驱动开奖闸门的安全阀和
 * 结果定格。手机快 30 秒的话，闸门一出现就被判定过期，整段开奖演出根本不会发生。
 *
 * <p>这套判断原本内联在 RoomPage 里，现在两处共用，抽出来才好测。
 */

/**
 * @param serverEpochSec 服务端在响应里给的时刻，秒
 * @param receivedAtMs   这个响应**到达客户端**的时刻（react-query 的 dataUpdatedAt）
 * @returns 应加到本地时钟上的秒数；不可信或差得太小时返回 0
 */
export function clockSkewSec(
  serverEpochSec: number | null | undefined,
  receivedAtMs: number | null | undefined,
): number {
  const server = Number(serverEpochSec);
  const received = Number(receivedAtMs);
  if (!Number.isFinite(server) || server <= 0) return 0;
  if (!Number.isFinite(received) || received <= 0) return 0;
  // 和「收到的那一刻」比，而不是和「现在」比 —— 这样网络延迟被抵掉，
  // 剩下的才是设备时钟自己的偏差。
  const skew = server - Math.floor(received / 1000);
  // 几秒之内就别校正了：那点差距对玩家无所谓，而校正会把网络抖动引进倒计时，
  // 让秒数忽快忽慢，比差几秒难看得多。
  if (Math.abs(skew) <= DEADBAND_SEC) return 0;
  // 超过半天，更可能是坏数据而不是真的时钟偏差。信了它会把这一批响应上的
  // 所有人的倒计时都搞坏。
  return Math.abs(skew) > SANITY_CAP_SEC ? 0 : skew;
}

export const DEADBAND_SEC = 3;
export const SANITY_CAP_SEC = 12 * 3600;
